<template>
  <ResponsiveFilterSheet
    :filters.sync="localFilters"
    :search-query.sync="localSearchQuery"
    :hide-search-input="hideSearchInput"
    :mobile-sheet="mobileSheet"
    @search="$emit('search')"
    @clear="$emit('clear')"
  >
    <template v-slot:desktop>
      <SearchTools
        :searchQuery.sync="localSearchQuery"
        :hide-search-input="hideSearchInput"
        @do-search="$emit('search')"
        @do-clear="$emit('clear')"
      >
        <template v-slot:prepend>
          <ServiceVisitFilterFields
            :filters="localFilters"
            :mechanics="mechanics"
            :priorities="priorities"
            :service-locations="serviceLocations"
            :statuses="statuses"
            :show-mechanic="showMechanic"
            :show-priority="showPriority"
            :show-status="showStatus"
            @update-filter="updateFilter"
          />
        </template>
      </SearchTools>
    </template>

    <template v-slot:mobile-fields="{ filters: draftFilters, updateFilter }">
      <ServiceVisitFilterFields
        :filters="draftFilters"
        :mechanics="mechanics"
        :priorities="priorities"
        :service-locations="serviceLocations"
        :statuses="statuses"
        :show-mechanic="showMechanic"
        :show-priority="showPriority"
        :show-status="showStatus"
        stacked
        @update-filter="updateFilter"
      />
    </template>
  </ResponsiveFilterSheet>
</template>

<script>
import ResponsiveFilterSheet from "@/core/components/table/ResponsiveFilterSheet.vue";
import SearchTools from "@/core/components/table/SearchTools.vue";
import ServiceVisitFilterFields from "@/modules/service-visits/components/ServiceVisitFilterFields.vue";

export default {
  name: "ServiceVisitFilters",
  components: {
    ResponsiveFilterSheet,
    SearchTools,
    ServiceVisitFilterFields
  },
  props: {
    filters: {
      type: Object,
      required: true
    },
    searchQuery: {
      type: String,
      default: ""
    },
    mechanics: {
      type: Array,
      default: () => []
    },
    priorities: {
      type: Array,
      default: () => []
    },
    serviceLocations: {
      type: Array,
      default: () => []
    },
    statuses: {
      type: Array,
      default: () => []
    },
    showMechanic: {
      type: Boolean,
      default: true
    },
    showPriority: {
      type: Boolean,
      default: true
    },
    showStatus: {
      type: Boolean,
      default: true
    },
    hideSearchInput: {
      type: Boolean,
      default: false
    },
    mobileSheet: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    localSearchQuery: {
      get() {
        return this.searchQuery;
      },
      set(value) {
        this.$emit("update:searchQuery", value);
      }
    },
    localFilters: {
      get() {
        return this.filters;
      },
      set(value) {
        this.$emit("update:filters", value);
      }
    }
  },
  methods: {
    updateFilter(key, filterValue) {
      this.localFilters = {
        ...this.localFilters,
        [key]: Array.isArray(filterValue) ? filterValue : filterValue || null
      };
      this.$emit("search");
    }
  }
};
</script>
